<template>
  <el-dialog
    title="批量导入案件结果"
    :visible="visible"
    :append-to-body="true"
    width="600px"
    :destroy-on-close="true"
    :show-close="true"
    @close="cancel"
    :close-on-click-modal="false"
  >
    <div class="content">
      <div
        style="
          flex: 1;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
        "
      >
        <div class="progress">
          <i v-if="progressInfo.importStatus === 'SUCC'" class="el-icon-success"></i>
          <i v-if="progressInfo.importStatus === 'FAIL'" class="el-icon-error" ></i>
        </div>

        <div class="tit">
          {{ progressInfo.importStatus === "SUCC" ? "导入完成" : "导入失败" }}
          <!-- 导入完成 -->
        </div>
      </div>
      <div class="tit mt20 text-left" v-if="progressInfo.importStatus === 'SUCC'">
        <span>导入业务成功</span>
        <el-tag effect="light" style="line-height: 20px; height: 20px; top: 0"
          >{{(progressInfo.contractAmount - progressInfo.failAmount).toFixed(0) }}件</el-tag>
        ，
        <span>导入业务失败</span>
        <el-tag
          type="danger"
          effect="light"
          style="line-height: 20px; height: 20px; top: 0"
          >{{ progressInfo.failAmount || 0 }}件</el-tag
        >
      </div>
      <div
        class="bgc success"
        v-if="progressInfo.importStatus === 'SUCC'"
        style="margin-bottom: 16px"
      >
        <i class="el-icon-warning"></i>
        <span>导入失败的业务可以通过编辑来进行修复</span>
      </div>
      <div
        class="fail"
        v-if="
          progressInfo.importStatus === 'FAIL' ||
          (progressInfo.importStatus === 'SUCC' && progressInfo.failReason)
        "
      >
        <h4>失败原因：</h4>
        <div
          class="mb5 row_5_omit"
          v-for="reason in progressInfo.failReason"
          :key="reason"
        >
          {{ reason }}
        </div>
      </div>
      <!-- <div
        class="bgc"
        v-if="
          progressInfo.importStatus === 'FAIL' ||
          (progressInfo.importStatus === 'SUCC' && progressInfo.failReason)
        "
      >
        <i class="el-icon-warning"></i>
        此处只能展示部分失败原因，具体原因请i查看列表中的[导入数据备注]
      </div> -->
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="close">我知道了</el-button>
        <el-button type="danger" @click="onSubmit" v-if="progressInfo.importStatus === 'SUCC'">批量提交成功业务</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    progressInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    importId: {
      type: String,
      default: ""
    }
  },
  components: {},
  data() {
    return {
      percentage: 0,
      isSubmit: false,
      isDetail: false,
      isAgentDetail: false,
      text: "",

      isClick: false,
    };
  },
  methods: {
    cancel() {
      this.$emit("update:visible", false);
    },

    close() {
      this.$emit('close')
    },

    created() {
    },

    // 提交
    onSubmit() {
      if (this.isClick) {
        return;
      }
      this.isClick = true;
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken("/import/batchSubmit", {
        importId: this.importId,
      }).then(
        (data) => {
          this.$store.commit("showLoading", false);
          if (data.code == 200) {
            this.$message.success("提交成功");
            this.$emit('submit')
            this.close();
          } else {
            this.$message.error(data.message);
          }
          this.isClick = false;
        },
        (err) => {
          this.$store.commit("showLoading", false);
          this.isClick = false;
        }
      );
    }
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.content {
  height: 400px;
  //margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 32px;
  .mb5 {
    font-size: 14px;
  }
  .bgc {
    color: #808080;
    position: relative;
    margin: 12px 0 0;
    font-size: 12px;
    width: 100%;
    i {
      color: #ff8c22;
    }
  }
  .tit {
    font-size: 14px;
    //margin: 10px 0;
  }
  .progress {
    width: 360px;
    text-align: center;
    i {
      font-size: 80px;
      color: #67c23a;
      &.el-icon-error {
        color: #ff0000;
      }
    }
  }

  .fail {
    //padding-left: 50px;
    width: 100%;
    border-top: 1px dashed #e5e5e5;
    i {
      color: #ff0000;
    }
    h4 {
      margin: 10px 0;
    }
  }
  .text-left {
    margin-bottom: 10px;
    width: 100%;
    .el-tag {
      margin-left: 5px;
    }
  }
  /deep/.el-tag--light {
    border: none;
    position: relative;
    top: -4px;
  }
}
.info {
  padding-left: 50px;
  width: 100%;
}
.mbb40 {
  margin-bottom: 40px !important;
}
.row_5_omit {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
/deep/ .el-dialog__body {
  padding-top: 0;
}
/deep/ .dialog-footer {
  width: 100%;
  display: flex;
  justify-content: right;
  padding-bottom: 20px;
  margin-top: 12px;
  button {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    line-height: 14px;
    font-size: 14px;
  }
}
::v-deep .el-button--danger {
  color: #fff;
  background-color: #db1c1b;
  border-color: #db1c1b;
  font-size: 12px;
}
::v-deep .el-button--danger.is-disabled,
.el-button--danger.is-disabled:active,
.el-button--danger.is-disabled:focus,
.el-button--danger.is-disabled:hover {
  color: #fff;
  background-color: #fab6b6;
  border-color: #fab6b6;
}
</style>
